import {User, Business, Team, TeamAssignment} from "@irati/types"

export function isGlobalAdmin(business: Business, user: User) {
  if (user && user.isGlobalAdmin) {
    return user.isGlobalAdmin
  }
  if (user && !user.role) {
    // Probably deprecated, leaving for safety.
    return business.globalAdminIds.includes(user.uuid)
  }
  return false
}

export function isManagerOfTeam(team: Team, user: User) {
  const found = user?.teamAssignments?.find((t) => t.teamId === team.uuid)
  if (found) {
    // we only use one assignment level, manager or leader, same thing
    return found.assignment === TeamAssignment.Leader || found.assignment === TeamAssignment.Manager
  }

  return false
}

export function isLeaderOfTeam(team: Team, user: User) {
  return isManagerOfTeam(team, user)
}
